import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

// Auto-logout de segurança: apenas teto absoluto de 8h por sessão (sem inatividade).
const MAX_SESSION_MS = 8 * 60 * 60 * 1000;
const CHECK_INTERVAL_MS = 30 * 1000;

const SESSION_START_KEY = "session_started_at";

export function useSessionTimeout() {
  const loggingOutRef = useRef(false);

  useEffect(() => {
    let hasSession = false;

    const startSession = () => {
      if (!localStorage.getItem(SESSION_START_KEY)) {
        localStorage.setItem(SESSION_START_KEY, String(Date.now()));
      }
    };

    const clearSession = () => {
      localStorage.removeItem(SESSION_START_KEY);
    };

    const forceLogout = async (reason: string) => {
      if (loggingOutRef.current) return;
      loggingOutRef.current = true;
      clearSession();
      toast.error(reason);
      await supabase.auth.signOut(); // dispara SIGNED_OUT -> RequireAuth redireciona
    };

    const check = () => {
      if (!hasSession) return;
      const start = Number(localStorage.getItem(SESSION_START_KEY) || 0);
      if (start && Date.now() - start > MAX_SESSION_MS) {
        void forceLogout("Sessão expirada. Faça login novamente.");
      }
    };

    supabase.auth.getSession().then(({ data: { session } }) => {
      hasSession = !!session;
      if (hasSession) startSession();
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      hasSession = !!session;
      if (event === "SIGNED_IN") {
        loggingOutRef.current = false;
        startSession();
      } else if (event === "SIGNED_OUT") {
        clearSession();
      }
    });

    const interval = window.setInterval(check, CHECK_INTERVAL_MS);

    return () => {
      subscription.unsubscribe();
      window.clearInterval(interval);
    };
  }, []);
}
